export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Предложения"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мои сделки"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мои объявления"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сделки"])}
}